import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  prereqs: [
    'Tener cargadas las Marcas de los equipos antes de agregar modelos.',
  ],
  tips: [
    'Cada modelo debe estar asociado a una marca existente.',
    'Usá el nombre exacto del fabricante para facilitar la búsqueda.',
    'Si hay variantes del mismo modelo (año, serie), crealas por separado.',
  ],
  nextSteps: [
    'Dar de alta equipos y asignarles su modelo.',
    'El modelo del equipo aparece en planillas y reportes.',
  ],
};

const ConfiguracionModelos = () => (
  <ConfiguracionBase
    apiEndpoint="modelos"
    titulo="Modelos"
    descripcion="Modelos específicos por marca"
    icon="fas fa-list-alt"
    compact
    help={HELP}
  />
);

export default ConfiguracionModelos;
